export const firstPartyStorage = [
  {
    name: 'i18nextLng',
    type: 'localStorage',
    category: 'necessary',
    durationKey: 'untilClear',
    purposeKey: 'lang',
    party: 'doksan.com',
    transfer: false,
  },
  {
    name: 'doksan_cookie_consent',
    type: 'localStorage',
    category: 'necessary',
    durationKey: 'twelveMonths',
    purposeKey: 'consent',
    party: 'doksan.com',
    transfer: false,
  },
];

export const alwaysEmbeds = [
  {
    name: 'YouTube (youtube-nocookie.com)',
    category: 'functional',
    party: 'Google LLC (ABD)',
    purposeKey: 'youtube',
    gated: false,
  },
  {
    name: 'Google Haritalar (maps embed)',
    category: 'functional',
    party: 'Google LLC (ABD)',
    purposeKey: 'maps',
    gated: false,
  },
];

export const gatedEmbeds = [];

export const outboundLinks = [
  {
    name: 'Google Maps yol tarifi / konum',
    path: 'Footer, İletişim',
    url: 'maps.app.goo.gl, google.com/maps',
    party: 'Google LLC (ABD)',
    purposeKey: 'mapsLink',
  },
  {
    name: 'Ulula şikayet hattı',
    path: 'Footer',
    url: 'https://s.ulula.app/S4Cturkey',
    party: 'Ulula',
    purposeKey: 'ulula',
  },
  {
    name: 'Bilgi Toplumu Hizmetleri',
    path: 'Header, Footer',
    url: 'https://www.belgemodul.com/sirket/604',
    party: 'Belge Modül',
    purposeKey: 'belge',
  },
  {
    name: 'Sürdürülebilirlik raporu',
    path: 'Sürdürülebilirlik sayfası',
    url: 'https://online.flippingbook.com/view/668661133/',
    party: 'FlippingBook',
    purposeKey: 'flip',
  },
  {
    name: 'Marka siteleri',
    path: 'Anasayfa — Markalar',
    url: 'kesehome.com, pioette.com',
    party: 'İlgili marka siteleri',
    purposeKey: 'brands',
  },
];

export const notUsed = [
  'Google Analytics',
  'Google Tag Manager / googletagmanager.com / gtag.js',
  'Google Fonts (fonts.googleapis.com / fonts.gstatic.com)',
  'Facebook / Meta piksel',
  'Moove GDPR eklentisi',
  'Reklam, yeniden hedefleme veya pazarlama çerezi',
  'İletişim formu (sitede form yoktur)',
];
